@let isDialogMode = assistant.state.isDialogMode();
@let isFullscreen = assistant.state.isFullscreenMode();

<div
  class="assistant-menu-button clickable"
  [class.collapsed]="isCollapsed()"
  [class.dialog-mode]="isDialogMode"
  [class.fullscreen-mode]="isFullscreen"
  (click)="onClicked($event)"
>
  <div class="icon-wrapper">
    @if (isDialogMode) {
      <app-icon-ai-chat-bold></app-icon-ai-chat-bold>
    } @else {
      <app-icon-ai-chat-outline
        [color]="isFullscreen ? 'var(--color-gray-0)' : 'var(--color-gray-500)'"
      ></app-icon-ai-chat-outline>
    }
  </div>

  @if (!isCollapsed()) {
    <div
      class="text-wrapper text-16 fw-500"
      [class.color-gray-0]="isFullscreen"
      [class.color-gray-500]="!isFullscreen"
    >
      {{ 'support-chat.ai-support' | translate }}
    </div>

    @if (!device.isMobile()) {
      <div class="icon-wrapper clickable">
        @if (isFullscreen) {
          <app-icon-ai-chat-minimize
            [appTooltip]="'support-chat.tooltips.compact-view' | translate"
            [tooltipPosition]="'top'"
            [color]="'var(--color-gray-0)'"
            (click)="assistant.minimize(); $event.stopPropagation()"
          ></app-icon-ai-chat-minimize>
        } @else {
          <app-icon-ai-chat-maximize
            [appTooltip]="'support-chat.tooltips.full-screen-view' | translate"
            [tooltipPosition]="'top'"
            [color]="'var(--color-gray-500)'"
            (click)="assistant.maximize(); $event.stopPropagation()"
          ></app-icon-ai-chat-maximize>
        }
      </div>
    }
  }
</div>
